import Main from "./Main";
import { useMainHook } from "./MainHook";

const MainContainer = () => {
  return <Main {...useMainHook()} />;
};

export default MainContainer;
